module.exports = __webpack_public_path__ + "hr.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/hr.svg
// module id = 598
// module chunks = 0